import { Strategy } from "./InvestmentStrategyContext";

export const strategies: Strategy[] = [
  {
    id: "diversification",
    label: "Diversification",
    title: "Asset Diversification",
    description: "Spread risk across uncorrelated assets, balancing exposure to traditional asset classes and alternatives.",
    points: [
      "Focused on reducing overall portfolio risk through exposure to uncorrelated assets.",
      "Expecting moderate volatility, willing to accept some risk but avoids large swings.",
      "Seeking steady, risk-adjusted returns that outpace inflation.",
      "Comfortable with a medium to long-term horizon, with moderate liquidity needs.",
      "Prioritizing risk management and balanced exposure over maximizing returns.",
    ],
    allocation: {
      stocks: 40,
      bonds: 30,
      cash: 10,
      alts: 20,
    },
  },
  {
    id: "income",
    label: "Income",
    title: "Income Generation",
    description: "Maximize income generation through assets that provide regular cash flow.",
    points: [
      "Focused on maximizing regular income through interest, dividends, or rent.",
      "Expecting low to moderate volatility and seeks stability in returns.",
      "Looking for steady income generation with modest capital growth.",
      "Has a medium-term horizon, with a need for liquidity to fund regular expenses.",
      "Income-focused, preferring stable, cash-flow-generating assets over risky investments.",
    ],
    allocation: {
      stocks: 30,
      bonds: 40,
      cash: 15,
      alts: 15,
    },
  },
  {
    id: "growth",
    label: "Growth",
    title: "Long-term Growth",
    description: "Maximize capital appreciation, willing to take on more risk for higher potential returns.",
    points: [
      "Focused on maximizing capital appreciation by investing in high-growth assets.",
      "Expecting high volatility and comfortable with large fluctuations in portfolio value.",
      "Seeking above-average returns, with an emphasis on long-term wealth creation.",
      "Comfortable with a long-term horizon, often in illiquid assets with delayed payouts.",
      "Primarily growth-oriented, willing to take on significant risk for potential future gains.",
    ],
    allocation: {
      stocks: 50,
      bonds: 20,
      cash: 10,
      alts: 20,
    },
  },
  {
    id: "preservation",
    label: "Preservation",
    title: "Asset Preservation",
    description: "Preserve capital with low volatility and minimal risk.",
    points: [
      "Focused on preserving capital and minimizing risk, with low volatility expectations.",
      "Expecting very low volatility and values stability and predictability in returns.",
      "Seeking modest returns, mainly to protect against inflation without eroding principal.",
      "Prefers a short to medium-term horizon, with a high demand for liquidity.",
      "Highly conservative, more concerned with avoiding losses than seeking gains.",
    ],
    allocation: {
      stocks: 20,
      bonds: 40,
      cash: 30,
      alts: 10,
    },
  },
];